export const isNetworkErrorCode = (statusCode: number): boolean => statusCode === 0;

export const isClientErrorCode = (statusCode: number): boolean => statusCode >= 400 && statusCode < 500;

export const isNetworkOrClientErrorCode = (statusCode: number): boolean =>
    isNetworkErrorCode(statusCode) || isClientErrorCode(statusCode);
